export default {"src":"/_next/static/media/SIRI.ff09c488.svg","height":18,"width":18};